document.querySelectorAll('.tea-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    // Remove 'active' class from all buttons, add to clicked one
    document.querySelectorAll('.tea-btn').forEach(b => b.classList.remove('active'));
    this.classList.add('active');

    // Get the data-tab value and button text
    const tabId = this.getAttribute('data-tab');
    const tabText = this.textContent.trim();

    // Hide all tabs
    document.querySelectorAll('.collection-tab').forEach(tab => tab.classList.add('hidden'));
    // Show the matching tab
    const target = document.getElementById(tabId);
    if (target) {
      target.classList.remove('hidden');
    }

    // Update the tea-type class
    document.querySelectorAll('.tea-type').forEach(tt => {
      tt.textContent = '';        // Empty
      tt.textContent = tabText;   // Add new tab text
    });
  });
});


// Check if sort-by-bw element exists before adding event listener
const sortByBtn = document.querySelector('.sort-by-bw');
const options = document.querySelector('.sort-options-bw');

if (sortByBtn && options) {
  sortByBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    options.style.display = options.style.display === 'block' ? 'none' : 'block';
  });
}

if (sortByBtn && options) {

document.body.addEventListener('click', function() {
  document.querySelector('.sort-options-bw').style.display = 'none';
});

} 

document.querySelectorAll('.sort-options-bw li').forEach(li => {
  li.addEventListener('click', function(e) {
    const sortKey = this.getAttribute('data-sort');
    // Set active class for current sort option
    document.querySelectorAll('.sort-options-bw li').forEach(opt => opt.classList.remove('active'));
    this.classList.add('active');
    
    // Find the active tab
    const activeTab = document.querySelector('.collection-tab:not(.hidden)');
    if (!activeTab) return;

    // Get all product cards in that tab
    const cards = Array.from(activeTab.querySelectorAll('.product-grid__item'));
    // Sort array based on price (ascending/descending)
    cards.sort(function(a, b) {
      const priceA = parseFloat(a.getAttribute('data-price'));
      const priceB = parseFloat(b.getAttribute('data-price'));
      if (sortKey === 'price-ascending') {
        return priceB - priceA;
      } else {
       
         return priceA - priceB;
      }
    });

    // Select product grid inside active tab and re-append sorted items
    const activeTabgrid = activeTab.querySelector('.product-grid');
    cards.forEach(card => activeTabgrid.appendChild(card));
  });
});


function getHeaderSectionId() {
  return document
    .querySelector('[id^="shopify-section-sections--"][id*="header_section"]')
    ?.id.replace('shopify-section-', '');
}
// const headerSectionId = 'sections--18102980903025__header_section';
  const headerSectionId = getHeaderSectionId();
          function fetchSectionHtmlDirect() {
            const url = `${window.location.pathname}?section_id=${encodeURIComponent(headerSectionId)}`;

            return fetch(url, {
              method: 'GET',
              headers: {
                Accept: 'text/html',
              },
            }).then((res) => res.text());
          }
// listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-green-apple-watermelon-flavor-pack-of-4-tubes

// const listingaddToCartBtn1 = document.getElementsByClassName('listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-green-apple-watermelon-flavor-pack-of-4-tubes')[0];


// if (listingaddToCartBtn1) {
//   listingaddToCartBtn1.addEventListener('click', function (e) {
//     e.preventDefault();
//     alert("Hi");

//     const variantIdOne = this.dataset.variantOne;
//     const variantIdTwo = this.dataset.variantTwo;

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify({
//         items: [
//           { id: Number(variantIdOne), quantity: 2 },
//           { id: Number(variantIdTwo), quantity: 2 }
//         ]
//       })
//     })
//     .then(res => res.json())
//     .then(data => {
//          fetchSectionHtmlDirect().then((html) => {
//           const domId = `shopify-section-${headerSectionId}`;
//           const el = document.getElementById(domId);
//           if (el && html) el.outerHTML = html;
//            const drawerToggle = document.querySelector('.header-actions__cart-icon');
//               if (drawerToggle instanceof HTMLElement) {
//                 drawerToggle.click();
//                 console.log('header updated with product added');
//               }
//           }); 
//       // or trigger your theme’s cart drawer update function
//     })
//     .catch(err => console.error('Bundle add error', err));
//   });
// }

// //bundle 2
// const listingaddToCartBtn2 = document.getElementsByClassName('listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-green-apple-flavor-pack-of-2-tubes')[0];


// if (listingaddToCartBtn2) {
//   listingaddToCartBtn2.addEventListener('click', function (e) {
//     e.preventDefault();

//     const variantIdOne = 42937904857201;

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify({
//         items: [
//           { id: Number(variantIdOne), quantity: 2 }
//         ]
//       })
//     })
//     .then(res => res.json())
//     .then(data => {
//          fetchSectionHtmlDirect().then((html) => {
//           const domId = `shopify-section-${headerSectionId}`;
//           const el = document.getElementById(domId);
//           if (el && html) el.outerHTML = html;
//            const drawerToggle = document.querySelector('.header-actions__cart-icon');
//               if (drawerToggle instanceof HTMLElement) {
//                 drawerToggle.click();
//                 console.log('header updated with product added');
//               }
//           }); 
//       // or trigger your theme’s cart drawer update function
//     })
//     .catch(err => console.error('Bundle add error', err));
//   });
// }


// document.addEventListener('click', function (e) {

//   const btn = e.target.closest(
//     '.listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-green-apple-watermelon-flavor-pack-of-4-tubes'
//   );

//   if (!btn) return;

//   e.preventDefault();
//   e.stopImmediatePropagation();

//   // LOGICAL DISABLE CHECK
//   if (btn.classList.contains('is-disabled')) {
//     console.log('Button disabled – click blocked');
//     return;
//   }

//   const variantIdOne = btn.dataset.variantOne;
//   const variantIdTwo = btn.dataset.variantTwo;

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json'
//     },
//     body: JSON.stringify({
//       items: [
//         { id: Number(variantIdOne), quantity: 2 },
//         { id: Number(variantIdTwo), quantity: 2 }
//       ]
//     })
//   })
//   .then(() => {
//     fetchSectionHtmlDirect().then((html) => {
//       const el = document.getElementById(
//         `shopify-section-${headerSectionId}`
//       );
//       if (el && html) el.outerHTML = html;

//       document
//         .querySelector('.header-actions__cart-icon')
//         ?.click();
//     });

//     // ATC animation
//     btn.classList.add('atc-added');
//     setTimeout(() => btn.classList.remove('atc-added'), 2000);
//   })
//   .catch(err => console.error('Bundle add error', err));

// });


// document.addEventListener('click', function (e) {

//   /* =========================
//      BUNDLE 4 (Pack of 4)
//   ========================== */
//   const bundle4Btn = e.target.closest(
//     '.listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-green-apple-watermelon-flavor-pack-of-4-tubes'
//   );

//   if (bundle4Btn) {
//     e.preventDefault();
//     e.stopImmediatePropagation();

//     if (bundle4Btn.classList.contains('is-disabled')) return;

//     const variantIdOne = bundle4Btn.dataset.variantOne;
//     const variantIdTwo = bundle4Btn.dataset.variantTwo;

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify({
//         items: [
//           { id: Number(variantIdOne), quantity: 2 },
//           { id: Number(variantIdTwo), quantity: 2 }
//         ]
//       })
//     })
//     .then(() => updateCartUI(bundle4Btn))
//     .catch(err => console.error('Bundle-4 add error', err));

//     return;
//   }

//   /* =========================
//      BUNDLE 2 (Pack of 2)
//   ========================== */

// });

// /* =========================
//    SHARED UI UPDATE
// ========================== */
// function updateCartUI(btn) {
//   fetchSectionHtmlDirect().then((html) => {
//     const el = document.getElementById(
//       `shopify-section-${headerSectionId}`
//     );
//     if (el && html) el.outerHTML = html;

//     document
//       .querySelector('.header-actions__cart-icon')
//       ?.click();
//   });

//   // ATC animation
//   btn.classList.add('atc-added');
//   setTimeout(() => btn.classList.remove('atc-added'), 2000);
// }



//working


document.addEventListener('click', function (e) {

  /* ============================
     BUNDLE 1 – GREEN APPLE + WATERMELON (PACK OF 4)
  ============================ */

  /* ============================
     BUNDLE 2 – GREEN APPLE (PACK OF 2)
  ============================ */
  const listingaddToCartBtn2 = e.target.closest(
    '.listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-green-apple-flavor-pack-of-2-tubes'
  );

  if (listingaddToCartBtn2) {
    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          { id: 42937904857201, quantity: 2 }
        ]
      })
    })
    .then(() => updateCartUI())
    .catch(err => console.error('Bundle 2 add error', err));

    return;
  }

  /* ============================
     BUNDLE 3 – GREEN APPLE (PACK OF 8)
  ============================ */
  const listingaddToCartBtn3 = e.target.closest(
    '.listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-green-apple-flavor-pack-of-8-tubes'
  );

  if (listingaddToCartBtn3) {
    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          { id: 42937904857201, quantity: 8 }
         
        ]
      })
    })
    .then(() => updateCartUI())
    .catch(err => console.error('Bundle 3 add error', err));

    return;
  }

   /* ============================
     BUNDLE 2 – GREEN APPLE (PACK OF 2)
  ============================ */
  const listingaddToCartBtn4 = e.target.closest(
    '.listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-green-apple-flavor-pack-of-4-tubes'
  );

 

  if (listingaddToCartBtn4) {
   
    e.preventDefault();
    e.stopImmediatePropagation();


   console.log("Deepak"+ listingaddToCartBtn4);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          { id: 42937904857201, quantity: 4 }
        ]
      })
    })
    .then(() => updateCartUI())
    .catch(err => console.error('Bundle 2 add error', err));

    return;
  }

  /* ============================
     BUNDLE 4 – WATERMELON (PACK OF 2)
  ============================ */
  const listingaddToCartBtn5 = e.target.closest(
    '.listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-watermelon-flavor-pack-of-2-tubes'
  );

  if (listingaddToCartBtn5) {
    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          { id: 42824543633521, quantity: 2 }
        ]
      })
    })
    .then(() => updateCartUI())
    .catch(err => console.error('Bundle 4 add error', err));

    return;
  }

  /* ============================
     BUNDLE 5 – WATERMELON (PACK OF 4)
  ============================ */
  const listingaddToCartBtn6 = e.target.closest(
    '.listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-watermelon-flavor-pack-of-4-tubes'
  );

  if (listingaddToCartBtn6) {
    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          
          { id: 42824543633521, quantity: 4 }
        ]
      })
    })
    .then(() => updateCartUI())
    .catch(err => console.error('Bundle 5 add error', err));

    return;
  }

  /* ============================
     BUNDLE 6 – WATERMELON (PACK OF 8)
  ============================ */
  const listingaddToCartBtn7 = e.target.closest(
    '.listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-watermelon-flavor-pack-of-8-tubes'
  );

  if (listingaddToCartBtn7) {
    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          
          { id: 42824543633521, quantity: 8 }
        ]
      })
    })
    .then(() => updateCartUI())
    .catch(err => console.error('Bundle 6 add error', err));
  }

});

/* ============================
   SHARED UI UPDATE (UNCHANGED)
============================ */
function updateCartUI() {
  fetchSectionHtmlDirect().then((html) => {
  const headerSectionId = getHeaderSectionId();

    const domId = `shopify-section-${headerSectionId}`;
    const el = document.getElementById(domId);
    if (el && html) el.outerHTML = html;

    document
      .querySelector('.header-actions__cart-icon')
      ?.click();
  });
}

document.addEventListener('click', function (e) {

  /* =========================
     BUNDLE 4 (Pack of 4)
  ========================== */
  const bundle4Btn = e.target.closest(
    '.listing_atc_metabolism-boost-tablets-green-tea-apple-cider-vinegar-green-apple-watermelon-flavor-pack-of-4-tubes'
  );

  

  if (!bundle4Btn) return;

  // prevent Shopify form submit
  e.preventDefault();

  const variantIdOne = bundle4Btn.dataset.variantOne;
  const variantIdTwo = bundle4Btn.dataset.variantTwo;

  // safety check
  if (!variantIdOne || !variantIdTwo) {
    console.error('Variant IDs missing');
    return;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [
        { id: Number(variantIdOne), quantity: 2 },
        { id: Number(variantIdTwo), quantity: 2 }
      ]
    })
  })
  .then(() => updateCartUI(bundle4Btn))
  .catch(err => console.error('Bundle-4 add error', err));
});



function disableBundleButtons(params) {
  // Support both object AND positional args
  const container = params?.container || (typeof params === 'string' ? params : '.collection-wrapper');
  const buttonClass = params?.buttonClass || '.bundle_add_to_cart';
  const textClass = params?.textClass || '.add-to-cart-text__content';
  const keywords = params?.keywords || ['apple', 'watermelon'];
  
  const containerEl = document.querySelector(container);
  if (!containerEl) return;
  
  containerEl.querySelectorAll(buttonClass).forEach(btn => {
    const hasKeyword = keywords.some(kw => 
      Array.from(btn.classList).some(cls => cls.includes(kw))
    );
    
    if (hasKeyword) {
      const textEl = btn.querySelector(textClass);
      if (textEl) {
        btn.classList.add('bundle-disabled');
        btn.disabled = true;
        textEl.textContent = 'Sold Out';
      }
    }
  });
}

// All calling styles work:
// disableBundleButtons();                                    

